import { format } from 'date-fns'

export const titleize = (text: string) => {
  return text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
}

export const prettyDateTime = (date: Date) => {
  return format(date, 'dd/MM HH:mm:ss')
}
